import { BfxBlotterOrdersContextMenuAcceptanceState } from "./BfxBlotterOrdersContextMenuAcceptanceState";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BfxBlotterOrdersContextMenuRejectState extends BfxBlotterOrdersContextMenuAcceptanceState {
  public ineligibleReject: boolean = false;

  constructor(
    public count: number = 0,
    public callCount: number = 0,
    public cancelCount: number = 0,
    public expiryCount: number = 0,
    public migrationCount: number = 0,
    public modifyInCount: number = 0,
    public modifyOutCount: number = 0,
    public newPendingCount: number = 0,
    public transferCount: number = 0,
  ) {
    super(
      count,
      callCount,
      cancelCount,
      expiryCount,
      migrationCount,
      modifyInCount,
      modifyOutCount,
      newPendingCount,
      transferCount,
    );
  }

  public addRejectRequest(type: CubiqTS.AcceptanceType, id: string) {
    if (!this.actionRequests.reject.acceptance.has(type)) {
      this.actionRequests.reject.acceptance.set(type, []);
    }

    this.actionRequests.reject.acceptance.get(type).push(id);
  }

  public addXferRejectRequest(targetDeskId: string, id: string) {
    if (!this.actionRequests.reject.xfer.has(targetDeskId)) {
      this.actionRequests.reject.xfer.set(targetDeskId, []);
    }

    this.actionRequests.reject.xfer.get(targetDeskId).push(id);
  }
}
